import React, {useContext, useEffect, useState} from 'react';
import * as Builder from "../../../builder";
import {Button} from "antd";
import {Translate} from "../../../components/util/translation.util";
import {ButtonBar} from "../../../builder";
import {TranslationDomainEnum} from "../../../types/enums";
import {observer} from "mobx-react";
import {StoreContext} from "../../../store.context";
import {RoleEditRequest} from "../../../types/request";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import {TextType} from "../../../builder/form/type/TextType";
import {MaxLengthConstraint, MinNumberConstraint, RequiredConstraint} from "../../../builder/form/validation/constraints";
import {TextareaType} from "../../../builder/form/type/TextareaType";
import {NumberType} from "../../../builder/form/type/NumberType";
import {RolePrepareEditFormResponse} from "../../../types/modules/role/response";

export const EditForm: React.FC<{ onCancel?: () => void }> = observer(({ onCancel}) => {
    const navigate = useNavigate();
    const params = useParams();
    const formReference = React.createRef() as any;
    const data: RolePrepareEditFormResponse = useLoaderData() as RolePrepareEditFormResponse;

    const [ fetching, setFetching ] = useState<boolean>(true)
    const [ formErrors, setFormErrors ] = useState<any>([])

    const { appStore: { moduleStore: { roleStore: {
        edit
    }}}} = useContext(StoreContext);

    useEffect(() => {
        setFetching(false);
        formReference.current?.setData(data.data)
    }, [data])

    const onSubmit = (values: RoleEditRequest) => {
        setFetching(true);
        edit({...values, id: params.id})
            .then((data) => {
                navigate(`/role/${data.id}/view`);
            })
            .catch(error => {
                setFormErrors(error.response.data.errors);
            })
            .finally(() => {
                setFetching(false);
            })
    }

    return (
        <>
            <Builder.Form
                translationDomain={TranslationDomainEnum.USER_ADMINISTRATION}
                formErrors={formErrors}
                ref={formReference}
                items={[{
                    title: <Translate message={`global.title.edit`} />,
                    position: 'left',
                    inputs: [
                        {
                            name: 'name',
                            label: 'role.field.name',
                            type: TextType,
                            constraints: [
                                MaxLengthConstraint(),
                                RequiredConstraint()
                            ]
                        },
                        {
                            name: 'level',
                            label: 'role.field.level',
                            type: NumberType,
                            constraints: [
                                MinNumberConstraint(),
                                RequiredConstraint()
                            ]
                        },
                        {
                            name: 'description',
                            label: 'role.field.description',
                            type: TextareaType,
                            constraints: [
                                MaxLengthConstraint(),
                            ]
                        }]
                    }
                ]}
                onFinish={(values: any) => { onSubmit(values); }}
                initialValues={data}
            />

            <ButtonBar>
                <Button loading={fetching} type="primary" htmlType={`submit`} onClick={() => {
                    formReference.current?.submitForm()
                }}><Translate message={`global.button.save`} /></Button>

                <Button type="primary" className={`ant-btn-secondary`} onClick={() => {
                    onCancel && onCancel()
                }}><Translate message={`global.button.back_to_list`} /></Button>
            </ButtonBar>
        </>
    )
})